import React from 'react';

const CaptchaSection = ({ 
  formData,
  captcha,
  captchaError,
  captchaDisabled,
  isSubmitting,
  handleChange,
  handleRefreshCaptcha
}) => {
  return (
    <div className="w-full">
      <h3 className="text-black font-semibold mb-4 sm:mb-6 font-poppins text-lg sm:text-xl">
        Spam Prevention
      </h3>
      
      <div className="max-w-full sm:max-w-md mx-auto p-4 sm:p-6 bg-white rounded-lg sm:rounded-xl border border-black/10 shadow-lg">
        <div className="font-mono tracking-wider sm:tracking-widest p-4 sm:p-5 rounded-lg select-none bg-gray-50 border border-black/10 mb-4 font-semibold text-lg sm:text-xl text-center">
          {captcha.code}
        </div>
        
        <button
          onClick={handleRefreshCaptcha}
          disabled={captchaDisabled || isSubmitting}
          className="w-full sm:w-auto mb-6 px-4 py-2 border border-gray-300 rounded-lg font-semibold font-poppins text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
        >
          Refresh Code
        </button>
        
        <div className="relative">
          <input
            type="text"
            value={formData.captchaCode}
            onChange={(e) => handleChange({ target: { name: 'captchaCode', value: e.target.value } })}
            required
            disabled={isSubmitting}
            placeholder="Enter Verification Code"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-center text-base sm:text-lg tracking-wider font-mono font-semibold"
          />
          {captchaError && (
            <p className="mt-1 text-sm text-red-600 font-poppins">{captchaError}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaptchaSection; 